"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.logSpecificErrorMessage = exports.logError = void 0;
var _processService = require("../process/processService");
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
} /* eslint-disable no-console */
var buildErrorKey = function buildErrorKey(moduleName) {
  return "COZY:ERROR:".concat(moduleName);
};
var logError = exports.logError = function logError(moduleName, error, errorInfo) {
  var errorKey = buildErrorKey(moduleName);
  if ((0, _processService.enableErrorTracker)()) {
    console.error("".concat(errorKey, "_START =====>"));
    console.error(error);
    console.error(errorInfo ? errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack : 'No errorInfo provided');
    console.error("<===== ".concat(errorKey, "_END"));
  }
};
var logSpecificErrorMessage = exports.logSpecificErrorMessage = function logSpecificErrorMessage(moduleName, message) {
  var errorKey = buildErrorKey(moduleName);
  if ((0, _processService.enableErrorTracker)()) {
    console.error("".concat(errorKey, ": ").concat(message));
  }
};
var logger = exports.logger = function logger() {
  var _console;
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';
  var param = arguments.length > 1 ? arguments[1] : undefined;
  var optionalParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  (_console = console)[method].apply(_console, [param].concat(_toConsumableArray(optionalParams.map(function (i) {
    return i;
  }))));
};